import Vue from 'vue';
import { FILTER_LOAD_BY_ID_ACTION, FILTER_CREATE_ACTION, FILTERS_LOAD_ACTION, 
    FILTER_PENALTY_VALUE_UPDATE_ACTION, FILTER_TYPE_DROPDOWNS_LOAD_ACTION } from '../action-types';
import { FILTER_LOAD_BY_ID_MUTATION, FILTER_CREATE_MUTATION, FILTERS_LOAD_MUTATION, 
    FILTER_CLEAR_OLD_DATA_MUTATION, FILTER_TYPE_DROPDOWNS_LOAD_MUTATION } from '../mutation-types';
import filterService from '../../services/api/Filters';

export const namespaced = true;

// initial state
export const state = {
    namespaced: true,
    filtersData: null,
    filterData: null,
    subscriptionFilterDropdows:{},
    oldFiltersData: null
};

// actions
export const actions = {    
    async [FILTERS_LOAD_ACTION]({ commit }) {
        const response = await filterService.getFilters();
        commit(FILTERS_LOAD_MUTATION, response.data);
        return response.data;
    },
    async [FILTER_LOAD_BY_ID_ACTION]({ dispatch, commit, state }, filterID) {   
        //getting all filters for the create page   
        if(state.filtersData == null) {
            await dispatch(FILTERS_LOAD_ACTION);
        }
        const response = await filterService.getFilterByID(filterID);
        commit(FILTER_LOAD_BY_ID_MUTATION, response.data);   
        return response.data;   
    },
    async [FILTER_CREATE_ACTION]({ commit }, filter) {   
        const response = await filterService.createFilter(filter);
        commit(FILTER_CREATE_MUTATION, response.data);
        return response;    
    },
    async [FILTER_PENALTY_VALUE_UPDATE_ACTION]({ commit }, filter) {   
        const response = await filterService.updateFilterPenaltyValue(filter);
        commit(FILTER_CREATE_MUTATION, response.data);
        return response;    
    },
    async [FILTER_TYPE_DROPDOWNS_LOAD_ACTION]({ commit }) {
        const response = await filterService.getSubscriptionFilterDropdowns();
        commit(FILTER_TYPE_DROPDOWNS_LOAD_MUTATION, response.data);
        return response.data;
    }
}


// mutations
export const mutations = {
    [FILTER_LOAD_BY_ID_MUTATION](state, filter) {
        state.filtersData = state.filtersData.map(store => {
            if (store.subscriptionFilterTypeID === (filter && filter.subscriptionFilterTypeId)) {
                state.oldFiltersData = JSON.parse(JSON.stringify(filter));
                return Object.assign({}, store, filter);
            }
            return store;
        });
    },
    [FILTER_CREATE_MUTATION](state, filter) {
        state.filtersData.push(filter);
    },
    [FILTERS_LOAD_MUTATION](state, filtersData) {
        Vue.set(state, 'filtersData', [...filtersData]);
    },
    [FILTER_CLEAR_OLD_DATA_MUTATION](state) {
        state.oldFiltersData = null
    },
    [FILTER_TYPE_DROPDOWNS_LOAD_MUTATION](state, subscriptionFilterDropdows){
        state.subscriptionFilterDropdows = subscriptionFilterDropdows
    }
  }

  export const getters = {
    getListOfFiltersNotAllowCampaign: state => {return state.filtersData.filter(row=>row.filterType.toLowerCase()!='campaign') },
  };